import React, { useCallback, useEffect, useMemo } from 'react'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import ToggleButtonContainer, { ToggleOption } from '../../ToggleButtonContainer'

interface Props {
  flightsAvailable: boolean
  flights: boolean
  isMemberPrice?: boolean
  hotelTotalPrice: number
  hotelFlightTotalPrice?: number
  pricesLoading?: boolean
}

function BaseHotelFlightsToggleButton(props: Props) {
  const { flightsAvailable, flights, isMemberPrice, hotelTotalPrice, hotelFlightTotalPrice, pricesLoading } = props
  const dispatch = useOfferPageDispatch()

  const noFlightsPrice = hotelTotalPrice === hotelFlightTotalPrice
  const disableFlights = !flightsAvailable || noFlightsPrice

  const handleOptionChange = useCallback((value: string) => {
    const isFlightsSelected = value === 'flights'
    dispatch({ type: OfferPageActions.toggleFlightsPrice, isFlightsSelected })
  }, [dispatch])

  useEffect(() => {
    if (!disableFlights && flights) {
      dispatch({ type: OfferPageActions.toggleFlightsPrice, isFlightsSelected: false })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disableFlights])

  const optionA: ToggleOption = useMemo(() => ({
    label: 'Hotel',
    value: 'hotel',
    displayPrice: hotelTotalPrice,
  }), [hotelTotalPrice])

  const optionB: ToggleOption = useMemo(() => ({
    label: 'Hotel + flights',
    value: 'flights',
    displayPrice: hotelFlightTotalPrice,
    buttonStartIcon: <LinePlaneDepartureIcon />,
  }), [hotelFlightTotalPrice])

  return (
    <ToggleButtonContainer
      optionA={optionA}
      optionB={optionB}
      selectedValue={flights ? 'flights' : 'hotel'}
      unavailableMessage={!flightsAvailable ? 'Unavailable for your dates' : undefined}
      isMemberPrice={isMemberPrice}
      pricesLoading={pricesLoading}
      disableOptionB={disableFlights}
      onOptionChange={handleOptionChange}
    />
  )
}

export default withOfferPageAndReduxState((state) => ({
  flights: state.flights,
}), BaseHotelFlightsToggleButton)
